// extracted by mini-css-extract-plugin
export default {"careDescriptionArea":"faqDressCare_careDescriptionArea__dWYRv","careSpan":"faqDressCare_careSpan__MCbjo"};